module.exports = __webpack_public_path__ + "img/gift-09-c1.d2617dd7.png";